import { useLazyQuery, useQuery } from "@apollo/client";
import { REFERENCE } from "../references.queries";
import {
  ReferenceQuery,
  ReferenceQueryVariables,
} from "../../../__generated__/ReferenceQuery";

export const useReference = (id: number) => {
  return useQuery<ReferenceQuery, ReferenceQueryVariables>(REFERENCE, {
    variables: { id },
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
  });
};

export const useLazyReference = () => {
  return useLazyQuery<ReferenceQuery, ReferenceQueryVariables>(REFERENCE);
};
